module.exports = __webpack_public_path__ + "img/sgs.a03659cf.jpg";